import importerReducers from 'src/modules/shared/importer/importerReducers';
import actions from 'src/modules/eventSchedule/importer/eventScheduleImporterActions';

export default importerReducers(actions);
